/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_Error_FetchInputs */

const en_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch salary data.`)
};

const de_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsdaten konnten nicht abgerufen werden.`)
};

const fr_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de récupérer les données salariales.`)
};

const es_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron obtener los datos salariales.`)
};

const it_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero dei dati salariali non riuscito.`)
};

const nl_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisgegevens ophalen mislukt.`)
};

const pl_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się pobrać danych o wynagrodzeniach.`)
};

const fi_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatietojen hakeminen epäonnistui.`)
};

const da_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke hente løndata.`)
};

const sv_salary_search_error_fetch = /** @type {(inputs: Salary_Search_Error_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte hämta lönedata.`)
};

/**
* | output |
* | --- |
* | "Failed to fetch salary data." |
*
* @param {Salary_Search_Error_FetchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_error_fetch = /** @type {((inputs?: Salary_Search_Error_FetchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_Error_FetchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_error_fetch(inputs)
	if (locale === "fr") return fr_salary_search_error_fetch(inputs)
	if (locale === "es") return es_salary_search_error_fetch(inputs)
	if (locale === "it") return it_salary_search_error_fetch(inputs)
	if (locale === "nl") return nl_salary_search_error_fetch(inputs)
	if (locale === "pl") return pl_salary_search_error_fetch(inputs)
	if (locale === "fi") return fi_salary_search_error_fetch(inputs)
	if (locale === "da") return da_salary_search_error_fetch(inputs)
	if (locale === "sv") return sv_salary_search_error_fetch(inputs)
	return en_salary_search_error_fetch(inputs)
});